import type { IconType } from "react-icons";
import { ColumnType } from "build-ts/enums";
import { AppIcons } from "constants/icons";

/** Matches ConfigurationPage entity nav: Metrics, Measures, Attributes, Datetime, Benchmarks (+ Metric). */
type OntologyEntityIconId = "metric" | "attribute" | "measure" | "benchmark" | "time";

export const ONTOLOGY_ENTITY_ICONS: Record<OntologyEntityIconId, IconType> = {
  metric: AppIcons.metric,
  attribute: AppIcons.attribute,
  measure: AppIcons.measure,
  benchmark: AppIcons.benchmark,
  time: AppIcons.timeframe,
};

export function iconForKgColumn(column_type: ColumnType | undefined): IconType {
  if (column_type === ColumnType.MEASURE) {
    return ONTOLOGY_ENTITY_ICONS.measure;
  }
  if (column_type === ColumnType.TEMPORAL) {
    return ONTOLOGY_ENTITY_ICONS.time;
  }
  return ONTOLOGY_ENTITY_ICONS.attribute;
}

/** Modal / page title when creating a KG entity of this type (type is fixed by entry point). */
export function kgCreateModalTitle(colType: ColumnType): string {
  if (colType === ColumnType.MEASURE) {
    return "Create Measure";
  }
  if (colType === ColumnType.TEMPORAL) {
    return "Create Time";
  }
  if (colType === ColumnType.ATTRIBUTE) {
    return "Create Attribute";
  }
  return "Create KG column";
}
